import styled from 'styled-components';

import { Button, ButtonProps } from '@components/button';
import { IconCloseRegular } from '@components/icons/close-regular';
import { pxToRem } from '@utils/converters';

export type ComboButtonProps = {
  leftButtonProps?: ButtonProps;
  rightButtonProps?: ButtonProps;
};

export const ComboButton = ({ leftButtonProps, rightButtonProps }: ComboButtonProps) => {
  const { variant: leftVariant = 'secondary', ...leftButtonRest } = leftButtonProps ?? {};
  const {
    iconLeft: rightIconLeft = <IconCloseRegular />,
    variant: rightVariant = 'secondary',
    ...rightButtonRest
  } = rightButtonProps ?? {};

  return (
    <ComboContainer>
      <Button variant={leftVariant} {...leftButtonRest} />
      <Button iconLeft={rightIconLeft} variant={rightVariant} {...rightButtonRest} />
    </ComboContainer>
  );
};

const ComboContainer = styled.div({
  display: 'flex',
  '>button:first-child': {
    borderTopRightRadius: pxToRem(0),
    borderBottomRightRadius: pxToRem(0),
  },
  '>button:nth-child(2)': {
    marginLeft: pxToRem(2),
    borderTopLeftRadius: pxToRem(0),
    borderBottomLeftRadius: pxToRem(0),
  },
});
